const BigNameCustomer = () => {
  return (
    <div class="gdlr-core-pbf-wrapper big-name-customer">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first">
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              style={{ padding: "25px 40px 0px 0px" }}
            >
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js  gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                    <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption">
                      <span class="gdlr-core-title-item-caption-prefix"></span>
                      Big Name Customers
                    </span>
                    <div class="gdlr-core-title-item-title-wrap ">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title">
                        Trusted by <br />
                        Industry Leaders
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space"
                    style={{ paddingBottom: "20px" }}
                  >
                    <div class="gdlr-core-text-box-item-content">
                      <p>
                        Prime Wave Technologies LLC specializes in software
                        engineering, delivering innovative and reliable
                        solutions that empower businesses. Our expert team
                        creates scalable software tailored to the needs of
                        global enterprises. Trusted by over 10 companies and
                        clients, we provide the technological edge required to
                        excel in a competitive market.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30"
            id="gdlr-core-column-2"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js "
              style={{ padding: "20px 0px 0px 0px" }}
            >
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-image-item gdlr-core-item-pdb  gdlr-core-center-align gdlr-core-item-pdlr"
                    style={{ paddingBottom: "0px" }}
                  >
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image  gdlr-core-image-item-style-rectangle"
                      style={{ borderWidth: "0px" }}
                    >
                      <img
                        src="assets/walkway.jpg"
                        alt=""
                        width="901"
                        height="597"
                        title="walkway"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BigNameCustomer;
